import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const FeedItem = ({ 
  type, 
  avatar, 
  avatarAlt, 
  userName, 
  action, 
  details, 
  timestamp, 
  likes, 
  comments,
  onLike,
  onComment 
}) => {
  const getActivityIcon = () => {
    switch (type) {
      case 'workout': return { name: 'Dumbbell', color: 'var(--color-accent)' };
      case 'achievement': return { name: 'Award', color: 'var(--color-warning)' };
      case 'class': return { name: 'Users', color: 'var(--color-primary)' };
      default: return { name: 'Activity', color: 'var(--color-success)' };
    }
  };

  const icon = getActivityIcon();

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm p-4 md:p-5 transition-smooth hover:shadow-md">
      <div className="flex items-start gap-3 md:gap-4">
        <div className="relative flex-shrink-0">
          <Image 
            src={avatar} 
            alt={avatarAlt}
            className="h-10 w-10 md:h-12 md:w-12 rounded-full object-cover"
          />
          <div className="absolute -bottom-1 -right-1 flex items-center justify-center h-5 w-5 md:h-6 md:w-6 rounded-full bg-card border-2 border-card">
            <Icon name={icon?.name} size={12} color={icon?.color} strokeWidth={2.5} />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <div className="mb-2">
            <span className="font-semibold text-foreground">{userName}</span>
            <span className="text-muted-foreground"> {action}</span>
          </div>
          {details && (
            <p className="text-sm text-foreground mb-2 line-clamp-2">{details}</p>
          )}
          <div className="flex items-center gap-4 text-xs md:text-sm text-muted-foreground">
            <span className="caption">{timestamp}</span>
            <button 
              onClick={onLike}
              className="flex items-center gap-1 hover:text-accent transition-smooth"
            >
              <Icon name="Heart" size={14} />
              <span>{likes}</span>
            </button>
            <button 
              onClick={onComment}
              className="flex items-center gap-1 hover:text-primary transition-smooth"
            >
              <Icon name="MessageCircle" size={14} />
              <span>{comments}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedItem;